<template>
  <div class="bg-white p-4 text-center">
    <!-- {{ item }} -->
    <div class="text-center font-bold">DELETE CONFIRMATION</div>
    <div class="my-4">Click to delete the department</div>
    <div class="py-4 text-center">
      <v-btn class="mr-2" @click="$emit('cancelDelete')" small>Cancel</v-btn>
      <v-btn small color="primary" @click="confirmDelete">Confirm Deletion</v-btn>
    </div>
  </div>
</template>


<script>
import EventBus from "@/EventBus";
import Axios from "axios";
export default {
  props: ["item"],
  methods: {
    confirmDelete() {
      let data = {
        department_id:this.item.department_id
      }
      Axios.post('/departments/delete', data).then((res) => {
        if (res.data.status) {
          EventBus.$emit("refreshDepartment");
        }
      });
    },
  },
};
</script>